import RS from '~/api';
import { UI_BUILD_NUMBER, UI_VERSION } from '~/config';
import { clickstreamLogger } from '~/logging';

/**
 * Выводит в консоль сообщения о ходе инициализации скрипта
 */
export const consoleNotification = (enableTrackingEvents: boolean, enableTrackingScenarios: boolean): void => {
  clickstreamLogger.info(
    `ClickStream Analytics UI module version ${UI_VERSION}-${UI_BUILD_NUMBER} initialized`
  );

  RS.productVersion.get().then((response): void => {
    clickstreamLogger.info(
      `ClickStream Analytics BH module version ${response.payload[0].version} detected`
    );
  });

  clickstreamLogger.info(
    `Tracking engine: ${
      enableTrackingEvents ? 'on' : 'off'
    }, Scenario engine: ${enableTrackingScenarios ? 'on' : 'off'}`
  );
};
